import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  Spinner,
  ModalBody,
  ModalFooter,
  ModalTitle,
} from "react-bootstrap";
import "./style.css";
import { Bar } from "react-chartjs-2";
import { ListarEntregadores } from "../../providers/EntregadorProvider";
import TBLPedidosEntregadores from "../../components/TBLPedidosEntregadores";
import ReactTable from "react-table";
import { KeyboardDatePicker } from "@material-ui/pickers";
import ModalHeader from "react-bootstrap/ModalHeader";
import Select from "react-select";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFDetalhesEntrega from "../../pdfs/PDFDetalhesEntregas";
import { listarPedidosByDateRange } from "../../providers/PedidoProvider";

export default class FinanceiroEntregadores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pedidos: [],
      pedidos_entregador: [],
      datas: [],
      entregas: [],
      faturamento: [],
      detalhamento_pedidos: [],
      entregas_por_entregador: [],
      dataInicio: null,
      dataFim: null,
      vendas_dia: [],
      pedido_grafico: [],
      modalEmitirRelatorio: false,
      entregadores: [],
      entregadorSelecionado: null,
      relatorioDisponivel: false,
      loading: false,
      totalFaturado: 0,
      modalShow: true,
    };
  }

  async componentDidMount() {
    const pedidos = [];
    const response = await ListarEntregadores();
    const dtFim = new Date();
    const dtIni = new Date();
    dtIni.setDate(dtIni.getDate() - 7);

    this.setState({
      pedidos,
      entregadores: response.map((e) => ({
        label: e.nome,
        value: e._id,
      })),
      modalShow: false,
      dataInicio: dtIni,
      dataFim: dtFim,
    });
    this.calcularFaturamento();
  }

  formartTables = (p, detalhamento_pedidos, entregas_por_entregador) => {
    const isEntregadorFixo = p.entregador?.entregador_fixo;
    detalhamento_pedidos.push({
      codigo: p.codigo,
      estabelecimento: p.estabelecimento,
      createdAt: p.createdAt,
      entregador: p.entregador,
      valor_frete: p.detalhes_pagamento.frete,
      valor_entregador: p.detalhes_pagamento.frete * (isEntregadorFixo ? 1 : 0.9),
      valor_ifeira: p.detalhes_pagamento.frete * (isEntregadorFixo ? 0 : 0.1),
    });
    if (
      p.entregador &&
      !entregas_por_entregador.some((e) => e.entregador === p.entregador.nome)
    ) {
      entregas_por_entregador.push({
        entregador: p.entregador ? p.entregador.nome : "",
        qtd_entregas: 1,
        total_faturado: p.detalhes_pagamento.frete * 0.9,
      });
    } else {
      entregas_por_entregador.forEach((e) => {
        if (e.entregador === (p.entregador ? p.entregador.nome : "")) {
          e.qtd_entregas += 1;
          e.total_faturado += p.detalhes_pagamento.frete * 0.9;
        }
      });
    }
  };

  calcularRelatorioPeriodo = async () => {
    const { dataInicio, dataFim, entregadorSelecionado } = this.state;
    this.setState({
      loading: true,
    });
    let totalFaturado = 0;
    const data = await listarPedidosByDateRange(dataInicio, dataFim);
    if (data) {
      const pedidos = data.filter(
        (pedido) =>
          pedido.status === "entregue" || pedido.status === "entrega_finalizada",
      );
      if (dataInicio && dataFim && entregadorSelecionado) {
        const pedidosFiltrados = [];
        pedidos.forEach((pedido) => {
          if (
            pedido.entregador &&
            pedido.entregador._id === entregadorSelecionado.value
          ) {
            totalFaturado += pedido.detalhes_pagamento.frete * 0.9;
            pedidosFiltrados.push(pedido);
          }
        });
        this.setState({
          pedidos_entregador: pedidosFiltrados,
          loading: false,
          relatorioDisponivel: true,
          totalFaturado,
        });
      } else if (entregadorSelecionado) {
        const pedidosFiltrados = [];
        pedidos.forEach((pedido) => {
          if (pedido.entregador && pedido.entregador._id == entregadorSelecionado.value) {
            totalFaturado += pedido.detalhes_pagamento.frete * 0.9;
            pedidosFiltrados.push(pedido);
          }
        });
        this.setState({
          pedidos_entregador: pedidosFiltrados,
          loading: false,
          relatorioDisponivel: true,
          totalFaturado,
        });
      } else {
        this.setState({ loading: false, totalFaturado: 0 });
      }
    }
  };

  calcularFaturamento = async () => {
    const { dataInicio, dataFim } = this.state;
    let detalhamento = [];
    let entregas_por_entregador = [];
    const datas = [];
    let mapPedido = new Map();
    let mapVendas = new Map();
    const dtIni = new Date(dataInicio);
    const dtFim = new Date(dataFim);
    const pedidos = await listarPedidosByDateRange(dataInicio, dataFim);
    const groupByMonth =
      dtFim.getMonth() !== dtIni.getMonth() &&
      dtFim.getFullYear() !== dtIni.getFullYear();
    pedidos.forEach((p) => {
      const date = p.agendado ? new Date(p.dataAgendamento) : new Date(p.createdAt);
      const dateKey = groupByMonth
        ? date.getMonth() + 1 + "/" + date.getFullYear()
        : date.getDate() + "/" + (date.getMonth() + 1);
      if (dataInicio && dataFim) {
        datas.push(date);
        if (mapPedido[dateKey] > 0) {
          mapPedido[dateKey] += p.detalhes_pagamento.frete;
        } else {
          mapPedido[dateKey] = parseFloat(p.detalhes_pagamento.frete.toFixed(2));
        }
        if (mapVendas[dateKey] > 0) {
          mapVendas[dateKey] += 1;
        } else {
          mapVendas[dateKey] = 1;
        }
        this.formartTables(p, detalhamento, entregas_por_entregador);
      }
    });
    let vendas_dia = Object.keys(mapVendas)
      .map((k) => mapVendas[k])
      .reverse();
    let pedido_grafico = Object.keys(mapPedido)
      .map((k) => mapPedido[k])
      .reverse();
    this.setState({
      pedidos: pedidos,
      datas: [
        ...new Set(
          datas
            .sort((a, b) => (a < b ? -1 : 1))
            .map((d) =>
              groupByMonth
                ? d.getMonth() + 1 + "/" + d.getFullYear()
                : d.getDate() + "/" + (d.getMonth() + 1),
            ),
        ),
      ],
      pedido_grafico,
      vendas_dia,
      detalhamento_pedidos: detalhamento,
      entregas_por_entregador: entregas_por_entregador.sort((a, b) =>
        a.qtd_entregas < b.qtd_entregas ? 1 : -1,
      ),
    });
  };

  render() {
    const { relatorioDisponivel } = this.state;
    return (
      <div>
        <br></br>
        <h3>Gráficos</h3>
        <Row>
          <Col md={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p style={{ marginBottom: 0, fontWeight: "bold" }}>Defina um período: </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}
              >
                <p style={{ marginRight: 30 }}>De</p>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  margin="normal"
                  id="date-picker-inline"
                  label="Data inicial"
                  value={this.state.dataInicio}
                  style={{ width: "60%" }}
                  maxDate={new Date()}
                  onChange={(d) => this.setState({ dataInicio: d })}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}
              >
                <p style={{ marginRight: 30 }}>Até</p>
                <KeyboardDatePicker
                  disableToolbar
                  disabled={!this.state.dataInicio}
                  variant="inline"
                  margin="normal"
                  id="date-picker-inline"
                  label="Data final"
                  minDate={this.state.dataInicio}
                  maxDate={new Date()}
                  value={this.state.dataFim}
                  style={{ width: "60%" }}
                  onChange={(d) => this.setState({ dataFim: d })}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 17,
                }}
              >
                <Button
                  style={{ height: 35 }}
                  onClick={() =>
                    this.calcularFaturamento(this.state.dataInicio, this.state.dataFim)
                  }
                >
                  Aplicar
                </Button>
                {this.state.dataInicio && this.state.dataFim ? (
                  <Button
                    variant="danger"
                    style={{ height: 35, marginLeft: 5 }}
                    onClick={() => {
                      this.setState({ dataInicio: new Date(), dataFim: null });
                      this.calcularFaturamento();
                    }}
                  >
                    Limpar
                  </Button>
                ) : null}
              </div>
            </div>
          </Col>
          <Col>
            <Button
              style={{ height: 35, marginTop: 51 }}
              onClick={() => this.setState({ modalEmitirRelatorio: true })}
            >
              Emitir Relatório
            </Button>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col md={6}>
            <h4>Entregas</h4>
            <Bar
              data={{
                labels: this.state.datas,
                datasets: [
                  {
                    type: "bar",
                    label: "Total Entregas",
                    fill: false,
                    borderColor: "#701B8C",
                    borderWidth: 1,
                    hoverBorderColor: "#ffffff",
                    data: this.state.vendas_dia,
                  },
                ],
              }}
              options={{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        min: 0,
                        stepSize: 5,
                      },
                    },
                  ],
                },
              }}
            />
          </Col>
          <Col md={6}>
            <h4>Faturamento</h4>
            <Bar
              data={{
                labels: this.state.datas,
                datasets: [
                  {
                    type: "bar",
                    label: "Total Faturado",
                    fill: false,
                    borderColor: "#701B8C",
                    borderWidth: 1,
                    hoverBorderColor: "#ffffff",
                    data: this.state.pedido_grafico,
                  },
                ],
              }}
              options={{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true,
                        min: 0,
                        stepSize: 50,
                      },
                    },
                  ],
                },
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={7}>
            <h4>Detalhamento das Entregas</h4>
            <TBLPedidosEntregadores data={this.state.detalhamento_pedidos} />
          </Col>
          <Col md={5}>
            <h4>Pedidos por Entregador</h4>
            <ReactTable
              data={this.state.entregas_por_entregador}
              className="-striped -highlight"
              style={{ height: 572, maxHeight: 572 }}
              showPaginationBottom={true}
              showPageSizeOptions={false}
              showPageJump={false}
              columns={[
                {
                  Header: "Entregador",
                  accessor: "entregador",
                  className: "center",
                },
                {
                  Header: "Qtd. Entregas",
                  accessor: "qtd_entregas",
                  className: "center",
                },
                {
                  Header: "R$ Faturado",
                  accessor: "total_faturado",
                  Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
                  className: "center",
                },
              ]}
              resizable
              previousText="Anterior"
              nextText="Próximo"
              loadingText="Carregando pedidos..."
              noDataText="Nenhum pedido encontrado!"
              pageText="Página"
              ofText="de"
              rowsText="linhas"
            />
          </Col>
        </Row>
        <Modal show={this.state.modalEmitirRelatorio}>
          <ModalHeader>
            <ModalTitle>Emitir relatório</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <br></br>
                <Row>
                  <Col>
                    <p style={{ marginBottom: 10, fontWeight: "bold" }}>
                      Selecione o entregador:{" "}
                    </p>
                    <Select
                      value={this.state.entregadorSelecionado}
                      options={this.state.entregadores}
                      onChange={(e) => {
                        this.setState({ entregadorSelecionado: e });
                      }}
                      isClearable
                      isSearchable
                      placeholder="Selecione o entregador"
                    ></Select>
                  </Col>
                </Row>
                <br></br>
                {this.state.entregadorSelecionado && relatorioDisponivel ? (
                  <PDFDownloadLink
                    document={
                      <PDFDetalhesEntrega
                        data={this.state.pedidos_entregador}
                        dataInicio={this.state.dataInicio}
                        dataFim={this.state.dataFim}
                        entregador={this.state.entregadorSelecionado}
                        totalFaturado={this.state.totalFaturado}
                      />
                    }
                    fileName={`relatorio-entrega-${new Date().toLocaleString()}.pdf`}
                    style={{
                      textDecoration: "none",
                      padding: "10px",
                      color: "white",
                      backgroundColor: "#701B8C",
                      border: "1px solid white",
                    }}
                  >
                    Baixar Relatório em PDF
                  </PDFDownloadLink>
                ) : null}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="secondary"
              onClick={() => this.setState({ modalEmitirRelatorio: false })}
            >
              Fechar
            </Button>
            <Button variant="primary" onClick={() => this.calcularRelatorioPeriodo()}>
              Emitir
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          show={this.state.modalShow}
          backdrop="static"
          keyboard={false}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
              Carregando...
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
